<template>
  <div
    v-if="showZoom"
    class="zoom"
  >
    <img
      v-if="media.type === 1"
      class="media-img"
      :src="media.url_media"
      alt=""
      loading="lazy"
    />
    <div
      v-else-if="media.type === 2"
      class="video"
    >
      <iframe
        :src="embedUrl ? embedUrl : ''"
        frameborder="0"
        allowfullscreen
        allowtransparency
        allow="autoplay"
        loading="lazy"
      />
    </div>
    <div
      class="close"
      @click="closeZoom"
    >
      <img
        src="~/assets/icons/cross.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { extractVideoId, buildEmbedUrl } from '~/utils/helpers'
import type { BvMedia } from '~/types'

const props = defineProps<{
  media: BvMedia
}>()
const emit = defineEmits(['close'])

const showZoom = ref(false)

const embedUrl = computed(() => {
  if (!props.media.url_media || props.media.type !== 2) return ''

  const info = extractVideoId(props.media.url_media)
  if (!info) return ''
  return buildEmbedUrl(info.source, info.id) ?? ''
})

watch(
  () => props.media,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue != null) {
      showZoom.value = true
    }
  },
  { immediate: true },
)

const closeZoom = () => {
  showZoom.value = false
  emit('close')
}
</script>

<style lang="scss" scoped>
.zoom {
  position: fixed;
  inset: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba($black, 0.8);

  .media-img {
    max-width: calc(100% - 16rem);
    max-height: calc(100% - 16rem);
    object-fit: contain;
  }

  .video {
    position: relative;
    width: calc(100% - 16rem);
    height: 0;
    padding-bottom: 56.25%;
    overflow: hidden;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .close {
    position: absolute;
    top: 2.5rem;
    right: 2.5rem;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
